import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { TimeTileConfig } from '@v2/pages/common/components/NCFileBatchEvents/types';
import ColorWrapper, { WithColor } from '@styles/colors';
import { TIME_TILE_MOBILE_CONFIG } from '@v2/pages/common/components/NCFileBatchEvents/components/TimeTilesMobile/constants';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { DOT_SIZE } from '@v2/pages/common/components/NCFileBatchEvents/constants';
import i18n from 'i18n-js';
import TimeDisplayInStaticFormat from '@components/common/TimeDisplayInStaticFormat';

interface TimeTileMobileProps extends WithColor {
  timeTileConfig: TimeTileConfig;
}

const TimeTileMobile: FC<TimeTileMobileProps> = ({ timeTileConfig, C }) => {
  const { height } = TIME_TILE_MOBILE_CONFIG;
  const { titleConfig, timeConfig, descriptionConfig } = timeTileConfig;

  return (
    <View
      style={{
        backgroundColor: C('Background/Light/Field'),
        height: scale(height),
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: scale(9),
        paddingHorizontal: scale(6),
        paddingVertical: scale(2),
        flex: 1,
      }}
    >
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: scale(3), justifyContent: 'center' }}>
        <View
          style={{
            width: scale(DOT_SIZE),
            height: scale(DOT_SIZE),
            backgroundColor: C(titleConfig.color),
            borderRadius: scale(scale(DOT_SIZE) / 2),
          }}
        />
        <Text style={[font['Caption 2'], { color: C(titleConfig.color) }]}>{i18n.t(titleConfig.text)}</Text>
      </View>
      <TimeDisplayInStaticFormat
        {...timeConfig}
        fontForDigit="Time 3"
        fontForDelimiter="Caption 1"
        fontForSecondDigit="Time 4"
        color="Label/Light/Primary"
        C={C}
      />
      <Text numberOfLines={2} style={[font['Caption 2'], { color: C('Label/Light/Quaternary'), textAlign: 'center' }]}>
        {i18n.t(descriptionConfig.text)}
      </Text>
    </View>
  );
};

export default ColorWrapper(TimeTileMobile);
